import React, { useState } from "react";
// types
import { TMainPageLayoutV2 } from "../type";
// utilities
import { 
    metaDataLanguageVersion,
} from "@/utilities/LanguageVersionSelectorShortcut";
// enums
import EContentType from "@/cms/enums/EContentType";
import SanitizeHTMLString from "@/utilities/SanitizeHTMLString";


const MNPG006 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG006.rendered", props);

    const [siteSettings] = useState(props.templates?.find((item) => item.contentType === EContentType.SITE_SETTING && item.parentId === props.template?.id));
    const [copyright] = useState(metaDataLanguageVersion("copyright", siteSettings?.languageVersions));

    if ( !props.template ) return null;

    return (
        <div className="copyright-area">
            <div className="container">
                <p className="ck-content" dangerouslySetInnerHTML={{ __html: SanitizeHTMLString(copyright)}} />
            </div>
        </div>
    )
}

const Component = React.memo(MNPG006, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG006.memo", { prevProps, nextProps });
    return true;
});

export default Component;
